import { QueryParams } from "@ofqual/portal-core/core/types";
import { useDispatch, useSelector } from "react-redux";
import { loadingExpansionApplicationList } from "../redux/actions";
import { expansionApplicationListSelector } from "../redux/selectors";

export const useExpansionApplicationState = (itemId: string, searchParams: QueryParams) => {
  const dispatch = useDispatch();

  const expansionApplicationsState = useSelector(expansionApplicationListSelector);
  const isCorrectRecordInRedux = expansionApplicationsState.itemId && expansionApplicationsState.itemId === itemId;

  if (!isCorrectRecordInRedux && expansionApplicationsState.status !== "LOADING") {
    dispatch(loadingExpansionApplicationList(itemId, searchParams));
  }

  return isCorrectRecordInRedux
    ? (expansionApplicationsState)
    : null;
};
